module.exports = __webpack_public_path__ + "ba4c94f8753fc6e32941a2f8bfcc01cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pattern/2.svg
// module id = 697
// module chunks = 0